import { ChevronRight } from '../../icons/ChevronRight';
import { Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppStateContext, ActivePane } from '../AppStateProvider/AppStateProvider';
import { DialecticaLogo } from '../../icons/DialecticaLogo';

const HeaderContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: `calc(100% - ${theme.navHeight}px)`,
  display: 'flex',
  justifyContent: 'center',
  zIndex: 100,
  background: 'inherit',
  // @ts-ignore
  [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
    display: 'none',
  },
}));

const Breadcrumb = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  '& p': {
    fontWeight: 600,
    color: '#AEB2C1',
    paddingRight: '2em',
    ...(active && {
      color: theme.typography.body1.color,
    }),
  },
  '&:last-child svg': {
    display: 'none',
  },
  [theme.breakpoints.only('md')]: {
    '& p': {
      width: '80%',
      textAlign: 'center',
    },
  },
}));

const ProgressBar = styled('div')({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  top: 'calc(100% - 2px)',
  background: '#CACDD8',
});

const ProgressBarForeground = styled('div')(({ theme }) => ({
  background: theme.palette.primary.main,
  width: '0',
  height: '100%',
  transition: 'width 1s ease',
}));

const MobileLogo = styled('div')(({ theme }) => ({
  display: 'none',
  // @ts-ignore
  [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
    display: 'block',
    margin: '2em 0 1.5em 1.5em',
  },
}));

const GridContainer = styled(Grid)(({ theme }) => ({
  justifyContent: 'space-between',
  height: '100%',
  flexWrap: 'wrap',
  [theme.breakpoints.only('md')]: {
    flexWrap: 'nowrap',
  },
}));

function HeaderItem({ label, pane }: { label: string; pane: ActivePane }) {
  const { state } = useAppStateContext();

  return (
    <Breadcrumb active={state.activePane >= pane}>
      <Grid container alignItems="center">
        <Typography variant="body1">{label}</Typography>
        <ChevronRight />
      </Grid>
    </Breadcrumb>
  );
}

export default function Header() {
  const { state } = useAppStateContext();

  const numberOfPanes = Object.keys(ActivePane).length / 2;

  return (
    <>
      <HeaderContainer>
        <Container>
          <GridContainer container alignItems="center">
            <HeaderItem pane={ActivePane.DeviceCheck} label="Device & Software Setup" />
            <HeaderItem pane={ActivePane.Connectivity} label="Connectivity" />
            <HeaderItem pane={ActivePane.Quality} label="Quality & Performance" />
            <HeaderItem pane={ActivePane.Results} label="Get Results" />
          </GridContainer>
        </Container>

        <ProgressBar>
          <ProgressBarForeground
            style={{ width: `${(state.activePane / (numberOfPanes - 1)) * 100}%` }}
          />
        </ProgressBar>
      </HeaderContainer>

      <MobileLogo>
        <DialecticaLogo />
      </MobileLogo>
    </>
  );
}
